<template>
    <v-container class="container" fluid>
        <v-toolbar dense dark color="secondary">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Check Statements</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon left to="/administration/fuel"><v-icon>mdi-arrow-left</v-icon></v-btn>
        </v-toolbar>
        <v-card class="mb-5">
            <v-form ref="form" lazy-validation>
                <v-data-table :headers="titles" :items="Statements" :loading="dataLoading"
                    loading-text="Loading... Please wait">
                    <template v-slot:item.view="x">
                        <v-btn @click="toViewFuelStatements(x.item)" icon>
                            <v-icon small>
                                mdi-eye
                            </v-icon>
                        </v-btn>
                    </template>
                    <templante v-slot:item.Date="{ x }">
                        <td v-if="x.Date == undefined">2023-03-23</td>
                    </templante>
                    <templante v-slot:item.Cost="{ x }">
                        <td v-if="x.Cost > 0">{{ x.Cost }}</td>
                        <td v-else>0</td>
                    </templante>
                </v-data-table>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'CheckStatements',
    data: function () {
        return {
            urlPdf: '',
            titles: [
                { text: 'Supplier Invoice No.', value: 'SuppInvNo' },
                { text: 'Supplier', value: 'Supplier' },
                { text: 'Date', value: 'Date' },
                { text: 'Recorded Amount', value: 'Cost' },
                { text: 'Unrecorded Amount ', value: 'CostExl' },
                { text: 'Unregistered records', value: 'TotalReg' },

                { text: 'View', value: 'view' }
            ],
            Statements: [],
            dataLoading: true
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData: function () {
            axios
                .get(
                    'fuel-expense/statements/' +
                    this.$store.state.checkStatements.start_date +
                    '/' +
                    this.$store.state.checkStatements.end_date,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(async response => {
                    var fuel = response.data['expense'].map(x => {
                        return {
                            SuppInvNo: parseInt(x.SuppInvNo),
                            Date: x.Date
                        }
                    });
                    var xlsx = response.data['excel'].map(x => {
                        return {
                            SuppInvNo: x.SuppInvNo,
                            Date: x.Date
                        }
                    });

                    var arr = fuel.concat(xlsx);
                    var unique = this.FilterDuplicate(arr,'SuppInvNo', 'Date');
                     console.log(unique , arr);
                      var statment = [];
                       unique.forEach(SuppInv => {
                          const xls = response.data['excel'].find(x =>{
                             return parseInt(x.SuppInvNo) === SuppInv.SuppInvNo && SuppInv.Date == x.Date;  
                          });
                          const expense = response.data['expense'].find(x =>{
                             return parseInt(x.SuppInvNo) === SuppInv.SuppInvNo && SuppInv.Date == x.Date;
                          });
                          console.log('Expenses',expense);
                          console.log('xls',xls);
                            if(expense !=  undefined && xls == undefined) {
                                expense.CostExl = 0;
                                expense.TotalReg = 0;
                                statment.push(expense);
                            }else if(expense == undefined && xls != undefined) {
                                xls.Cost = 0;
                                statment.push(xls);
                            }else if(expense == undefined && xls == undefined)
                            {}else{
                                console.log(expense,xls);
                                expense.CostExl = xls.CostExl;
                                expense.TotalReg = xls.TotalReg;
                                statment.push(expense);
                            }

                      });
                    this.Statements = response.data['expense'];
                     console.log(unique);
                    this.dataLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // Función para filtrar duplicados basados en dos propiedades
        FilterDuplicate: function (array, propiedad1, propiedad2) {
            const uniqueMap = new Map();
            const uniqueArray = [];

            for (const item of array) {
                const key = `${item[propiedad1]}_${item[propiedad2]}`;
                if (!uniqueMap.has(key)) {
                    uniqueMap.set(key, true);
                    uniqueArray.push(item);
                }
            }

            return uniqueArray;
        },
        toViewFuelStatements: function (item) {
            this.$store.state.viewFuelStatementsSuppInvNo.suppInvNo =
                item.SuppInvNo;
            this.$store.state.viewFuelStatements.from = 'checkStatements';
            this.$router.push('/Administration/fuel/view-fuel-statement');
        },
        printStatementSummaryReport: async function () {
            //POST /shift-detail/unfinalized-shifts/report

            var str = this.$store;

            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.checkStatements.start_date,
                EndDate: this.$store.state.checkStatements.end_date
            };

            axios
                .post('fuel-expense/statement-summary/', parms,
                    {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'qryCmbShfits.pdf');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        }
    }
};
</script>

<style></style>
